import { h } from '@stencil/core';

const ArrowRight = () => {
    return (
        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5.35001H13M13 5.35001L8.97605 1.35001M13 5.35001L8.97605 9.35001" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default ArrowRight;
